module.exports = __webpack_public_path__ + "img/race-promotions.8a2b2cc1.png";